var map = {
	"./10_yellow.mp3": "1e3f",
	"./72_baubles.mp3": "5e1c",
	"./73_bells.mp3": "fc77",
	"./74_stars.mp3": "ad5d",
	"./8_blue.mp3": "0877",
	"./8_red.mp3": "7e5b",
	"./M_Brilliant.mp3": "a1c6",
	"./M_Excellent.mp3": "8b52a",
	"./M_Fantastic.mp3": "700a",
	"./M_Great.mp3": "b937",
	"./M_Perfect.mp3": "5d6c",
	"./M_Think again.mp3": "75ad",
	"./M_Try again.mp3": "607f",
	"./M_Very good.mp3": "ebd6",
	"./M_Well done.mp3": "b192",
	"./M_Work harder.mp3": "373e",
	"./click.mp3": "ffce",
	"./false.mp3": "2e31",
	"./true.mp3": "635d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91a7";